import { post, get } from "../network/index.js";

//团单列表
const queryGroup = (data) => {
  return post("/mercWebi/webGroupInfo/listGroupInfo", data);
};
//新增团单
const addGroup = (data) => {
  return post("/mercWebi/webGroupInfo/insertGroupInfo", data);
};
//下载小程序码
const exportFile = (data) => {
  return get("/mercWebi/webGroupInfo/downloadWxCodeImg", data);
};
//删除团单
const delGroup = (data) => {
  return get("/mercWebi/webGroupInfo/deleteGroupInfo", data);
};
//根据店铺获取频道信息
const setChannnel = (data) => {
  return get("/mercWebi/webGroupInfo/getChannelInfo",data);
}
//复制团单
const cloneGroupInfo = (data) => {
  return get("/mercWebi/webGroupInfo/cloneGroupInfo", data);
};
//上下架团单
const setGroup = (data) => {
  return post("/mercWebi/webGroupInfo/updateGroupStatus", data);
};
//团单详情
const editGroup = (data) => {
  return post("/mercWebi/webGroupInfo/updateGroupInfo", data);
};
//团单详情
const qureyGroupInfo = (data) => {
  return get("/mercWebi/webGroupInfo/listGroupInfoById", data);
};
// 标签管理 - 获取下拉标签列表
const listSysLabelByParam = (data) => {
  return post("/mercWebi/webLabelInfo/listSysLabelByParam", data);
};

//团购 - 跨商家复制
const cloneGroup = (data) => {
  return post("/mercWebi/webGroupInfo/cloneGroup", data);
};
//团购 - 获取复制记录列表
const groupCloneInfo = (data) => {
  return post("/mercWebi/webGroupInfo/listGroupCloneInfo", data);
};
//团购 - 团单复制详情
const cloneDetailList = (data) => {
  return post("/mercWebi/webGroupInfo/listGroupCloneResultByCloneId", data);
};

//团购 - 排序
const sortExplosive = (data) => {
  return post("/mercWebi/explosive/sortExplosive", data);
};
// 团单 - 获取团单适用店铺分页查询
const listStoreInfoByGroupId = (data) => {
  return post("/mercWebi/webGroupInfo/listStoreInfoByGroupId", data);
};
// 团单 - 获取团单适用店铺
const queryStoreInfoByGroupId = (data) => {
  return post("/mercWebi/webGroupInfo/queryStoreInfoByGroupId", data);
};
// 团单 - 统计团单状态
const countGroupInfo = (data) => {
  return post("/mercWebi/webGroupInfo/countGroupInfo", data);
};
const listStoresByMercId = (data) => {
  return post("/mercWebi/webGroupInfo/listStoresByMercId", data);
};
// 服务时间方案
const getServiceTimePlanAll = (data) => {
  return post("/mercWebi/busServiceTime/getServiceTimePlanAll", data);
}

export default { 
  addGroup,
  queryGroup,
  delGroup,
  cloneGroupInfo,
  setGroup,
  qureyGroupInfo,
  editGroup,
  groupCloneInfo,
  cloneGroup,
  cloneDetailList,
  sortExplosive,
  queryStoreInfoByGroupId,
  countGroupInfo,
  listStoreInfoByGroupId,
  exportFile,
  setChannnel,
  listStoresByMercId,
  getServiceTimePlanAll,
  listSysLabelByParam,
  
};